import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	NewConsentDTO,
	NewConsentRequest,
	NewConsentSaveDTO,
} from '../DTO/forms-management/newConsent';

export const newConsent = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getNewConsentList: builder.query<SuccessResponse<NewConsentDTO[]>, string>({
			query: (id) => ({
				url: `/web/form/consent-personal-data-usage/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['NewConsentList'],
		}),
		deleteNewConsent: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/consent-personal-data-usage/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['NewConsentList'],
		}),
		newConsentHasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/consent-personal-data-usage/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getNewConsentDraft: builder.query<
			SuccessResponse<NewConsentSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/consent-personal-data-usage/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueNewConsentDraft: builder.mutation<
			SuccessResponse<NewConsentSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/consent-personal-data-usage/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editNewConsent: builder.mutation<SuccessResponse<any>, NewConsentRequest>({
			query: (body) => ({
				url: `/web/form/consent-personal-data-usage/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createNewConsent: builder.mutation<SuccessResponse<any>, NewConsentRequest>(
			{
				query: (body) => ({
					url: `/web/form/consent-personal-data-usage`,
					method: 'POST',
					body,
				}),
			}
		),
		getNewConsentDetail: builder.query<SuccessResponse<NewConsentDTO>, string>({
			query: (id) => ({
				url: `/web/form/consent-personal-data-usage/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetNewConsentListQuery,
	useDeleteNewConsentMutation,
	useNewConsentHasDraftQuery,
	useGetNewConsentDraftQuery,
	useContinueNewConsentDraftMutation,
	useEditNewConsentMutation,
	useCreateNewConsentMutation,
	useGetNewConsentDetailQuery,
} = newConsent;
